import React, { Suspense } from 'react';

import { FullscreenSpinner } from '@frontend/components/common';

interface Props {
    id?: string;
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

export const AsyncComponent = (props: Props) => {
    return (
        <Suspense
            fallback={
                props.fallback || (
                    <FullscreenSpinner
                        screenClassName='bg-background-surface'
                        spinner={{ className: 'size-16 text-brand-light fill-brand-primary' }}
                    />
                )
            }>
            {props.children}
        </Suspense>
    );
};

export default AsyncComponent;
